









































import { Component, Vue, Watch } from "vue-property-decorator";
import { tagList } from "@/req/home"
@Component({
  components: {},
})
export default class Logout extends Vue {
  public data: any = [];
  public datas: any = [];
  public active = null;
  public actives = null;
  public mounted() {
    this.gettagList()
  }
  public async gettagList() {
    const obj = {
      token: this.$fn.cookies.getToken(),
    };
    const res = await tagList(obj);
    if (res.code == 200) {
      if (res.data.versionList) {
        this.data = res.data.versionList
      }
      if (res.data.tagList) {
        this.datas = res.data.tagList
      }
    }
  }
  public addVersion(index) {
    if (this.$store.state.discover.active == index) {
      this.$store.state.discover.active = null;
      this.$store.state.discover.versions = null
      this.$store.state.discover.search = false
    } else {
      this.$store.state.discover.search = true
      this.$store.state.discover.active = index;
      this.data.forEach((item, ids) => {
        if (index == ids) {
          this.$store.state.discover.versions = item.id;
        }
      });
    }
  }
  public addTags(index) {
    if (this.$store.state.discover.actives == index) {
      this.$store.state.discover.actives = null;
      this.$store.state.discover.tag = null
      this.$store.state.discover.search = false
    } else {
      this.$store.state.discover.search = true
      this.$store.state.discover.actives = index;
      this.datas.forEach((item, ids) => {
        if (index == ids) {
          this.$store.state.discover.tag = item.tag_id;
        }
      });
    }
  }
}
